import { Translation } from '@ps/web-shared-components';
import { addYears, format } from 'date-fns';
import React from 'react';

import InfoMessage from '@swf/components/InfoMessage/InfoMessage';
import { StatusCode } from '@swf/core/enums/statusCode';

import { ExclusionTime } from '../../../shared/definitions';
import AccountDate from '../../AccountDate/AccountDate';

import {
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_5,
  TXTWCL_WeXll_automatically_reopen_you_ELL,
  TXTWCL_WeXll_automatically_reopen_you_ELL_1,
  TXTWCL_We_canXt_process_your_request__ELL_1,
  TXTWCL_YouXre_currently_self_excluded,
  TXTWCL_YouXre_taking_a_break,
  TXTWCL_Your_account_has_been_closed_a_ELL
} from './ExclusionResponseGR.messages.json';

interface Props {
  error?: boolean;
  statusCode?: StatusCode;
  timeUntil?: number | string;
  daysRequested?: number;
}

const ExclusionResponseGR: React.FC<Props> = ({ error, statusCode, timeUntil, daysRequested }) => {
  const indefiniteExclusion = daysRequested === ExclusionTime.Indefinite;
  const currentDate = new Date();
  let endDate;
  if (timeUntil) {
    endDate = new Date(timeUntil);
  } else {
    const daysToAdd =
      daysRequested && daysRequested > ExclusionTime.OneDay
        ? ExclusionTime.ThirtyDays
        : ExclusionTime.OneDay;
    endDate = currentDate.setDate(currentDate.getDate() + daysToAdd);
  }

  const indefiniteDate = currentDate.setFullYear(currentDate.getFullYear() + 1);

  const formattedEndDate = (
    <b>
      <AccountDate date={indefiniteExclusion ? indefiniteDate : endDate} />
    </b>
  );

  switch (true) {
    case error:
      return (
        <InfoMessage type="error">
          <Translation {...TXTWCL_We_canXt_process_your_request__ELL_1} />
        </InfoMessage>
      );
    case indefiniteExclusion:
      return (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_currently_self_excluded}>
          <Translation
            {...TXTWCL_Your_account_has_been_closed_a_ELL}
            values={{
              0: format(addYears(new Date(), 1), 'Pp')
            }}
          />
        </InfoMessage>
      );

    case statusCode === StatusCode.USER_SELF_EXCLUDED:
      return (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_taking_a_break}>
          <Translation
            {...TXTWCL_WeXll_automatically_reopen_you_ELL_1}
            values={{ 0: formattedEndDate }}
          />
        </InfoMessage>
      );

    default:
      return (
        <>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
            values={{ 0: formattedEndDate }}
          />{' '}
          <Translation {...TXTWCL_WeXll_automatically_reopen_you_ELL} />
        </>
      );
  }
};

export default ExclusionResponseGR;
